"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var hooks_1 = require("../../../../hooks");
var ConfigProvider_1 = require("../../../../providers/ConfigProvider");
var either_1 = require("../../../../utils/either");
var Dropdown_1 = require("../../inputs/Dropdown");
var RemovableDropdown_1 = __importDefault(require("../../inputs/RemovableDropdown"));
var Odvetvi_1 = __importDefault(require("./Odvetvi"));
var utils_1 = require("./utils");
var StyledObor = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 2em;\n"], ["\n  margin-bottom: 2em;\n"])));
var OborDropdown = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ",
    "\n  ",
    "\n"])), function (_a) {
    var $leadingInputBold = _a.$leadingInputBold;
    return $leadingInputBold && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", " {\n        font-weight: 700;\n      }\n    "], ["\n      ", " {\n        font-weight: 700;\n      }\n    "])), Dropdown_1.StyledControl);
}, function (_a) {
    var readOnly = _a.readOnly;
    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ",
        "\n  "])), readOnly &&
        "div {\n        margin-right: 0 !important;\n      }");
});
var Obor = function (_a) {
    var onChange = _a.onChange, obor = _a.obor, specializace = _a.specializace, value = _a.value, onRemove = _a.onRemove, disableAdd = _a.disableAdd, seek = _a.seek, placeHolder = _a.placeHolder, specializaceFilter = _a.specializaceFilter, onRemoveAny = _a.onRemoveAny, prioritni = _a.prioritni, readOnly = _a.readOnly, initialSpecs = _a.initialSpecs;
    var ciselnikyUrl = ConfigProvider_1.useConfig().ciselnikyUrl;
    var idSpecializace = utils_1.idSpecializaceProp(obor);
    var getJSON = hooks_1.useGetJSON(ciselnikyUrl + "/SpecializaceSeek");
    var treeIds = utils_1.getTreeIds(value);
    var usedIds = ramda_1.without([idSpecializace], treeIds);
    var options = ramda_1.pipe(utils_1.filterAvailable(usedIds), utils_1.mapSpecializaceToOptions)(specializace);
    var podrizeneLens = ramda_1.lensProp('podrizene');
    var handleChange = function (index) { return function (selectedOdvetvi) {
        var _a, _b;
        return onChange(__assign(__assign({}, obor), { idSpecializace: (_a = obor.idSpecializace) !== null && _a !== void 0 ? _a : (_b = utils_1.getSpecializaceById(selectedOdvetvi.idSpecializace || 0, specializace)) === null || _b === void 0 ? void 0 : _b.idNadrazene, podrizene: ramda_1.set(ramda_1.lensIndex(index), selectedOdvetvi, obor.podrizene) }));
    }; };
    var handleSelect = function (selectedObor) {
        if ((selectedObor === null || selectedObor === void 0 ? void 0 : selectedObor.idSpecializace) !== obor.idSpecializace) {
            onChange(ramda_1.set(podrizeneLens, [], selectedObor));
        }
    };
    var AddOdvetviAction = function () {
        onChange(ramda_1.over(podrizeneLens, ramda_1.append({}), obor));
    };
    var handleRemoveOdvetvi = function (index) { return function () {
        if (onRemoveAny)
            onRemoveAny(obor.podrizene[index].idSpecializace);
        onChange(__assign(__assign({}, obor), { podrizene: ramda_1.remove(index, 1, obor.podrizene) }));
    }; };
    var useFilter = function (opts) {
        var filtered = specializaceFilter ? opts.filter(function (o) { return specializaceFilter.includes(o.value); }) : opts;
        return filtered;
    };
    var loadOptions = function (search) { return __awaiter(void 0, void 0, void 0, function () {
        var params, response, filtered;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(seek && search)) return [3 /*break*/, 2];
                    params = {
                        slovo: search,
                    };
                    return [4 /*yield*/, getJSON(params)];
                case 1:
                    response = _a.sent();
                    if (either_1.isRight(response)) {
                        filtered = response.value.filter(function (v) { return !ramda_1.includes(v.idSpecializace, treeIds); });
                        return [2 /*return*/, useFilter(utils_1.mapSpecializaceToOptions(filtered))];
                    }
                    return [2 /*return*/, value && Object.keys(value).length ? useFilter(utils_1.mapSpecializaceToOptions([value])) : []];
                case 2: return [2 /*return*/, useFilter(options)];
            }
        });
    }); };
    return (react_1.default.createElement(StyledObor, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(OborDropdown, { "$leadingInputBold": !utils_1.isAddDisabled(disableAdd, 'odvetvi'), readOnly: readOnly },
                react_1.default.createElement(RemovableDropdown_1.default, { name: "obor", isSearchable: seek, value: idSpecializace, onChange: function (id) { return handleSelect(utils_1.findByIdSpecializace(id || null, specializace)); }, placeholder: placeHolder || 'Vyberte obor', loadOptions: loadOptions, onRemove: onRemove, showAdd: !readOnly, addString: "+ Odv\u011Btv\u00ED", onAdd: AddOdvetviAction, disabled: readOnly, showRemove: !readOnly, readOnly: readOnly }))),
        ramda_1.addIndex(ramda_1.map)(function (odvetvi, index) { return (react_1.default.createElement(Odvetvi_1.default
        // eslint-disable-next-line react/no-array-index-key
        , { 
            // eslint-disable-next-line react/no-array-index-key
            key: odvetvi.idSpecializace || "create-" + index, value: value, obor: obor, onRemove: handleRemoveOdvetvi(index), onChange: handleChange(index), odvetvi: odvetvi, specializace: utils_1.getPodrizene(obor.idSpecializace)(specializace), disableAdd: disableAdd, specializaceFilter: specializaceFilter, onRemoveAny: onRemoveAny, prioritni: prioritni, readOnly: readOnly, initialSpecs: initialSpecs })); }, utils_1.viewPodrizene(obor))));
};
Obor.defaultProps = {
    seek: false,
    disableAdd: false,
    placeHolder: undefined,
    specializaceFilter: undefined,
    onRemoveAny: undefined,
    prioritni: undefined,
    readOnly: undefined,
};
exports.default = Obor;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
